module.exports = __webpack_public_path__ + "static/tiktok-business-ed747e753c977a5d00f77d28f1be579b.jpg";